"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaterFitNav = void 0;
var React = require("react");
var WaterFitNav_style_1 = require("./WaterFitNav.style");
var helpers_1 = require("../../../helpers");
var Icon_1 = require("../../Icon/Icon");
var ToolTip_1 = require("../../ToolTip");
exports.WaterFitNav = function (props) {
    var _a = props.coins, coins = _a === void 0 ? 0 : _a, _b = props.waterUsage, waterUsage = _b === void 0 ? 0 : _b, isDesktop = props.isDesktop, style = props.style, tooltips = props.tooltips, litresCopy = props.litresCopy, id = props.id, restProps = __rest(props, ["coins", "waterUsage", "isDesktop", "style", "tooltips", "litresCopy", "id"]);
    return (React.createElement(WaterFitNav_style_1.default.WaterFitNavWrap, __assign({ "data-test": "waterFitBar", id: id, isDesktop: isDesktop, style: style }, restProps),
        React.createElement(WaterFitNav_style_1.default.Values, null,
            waterUsage === null ? null : (React.createElement(ToolTip_1.default, { content: tooltips === null || tooltips === void 0 ? void 0 : tooltips.water },
                React.createElement(WaterFitNav_style_1.default.ValueWrap, { "data-test": "water" },
                    React.createElement(Icon_1.default, { icon: "droplet", size: 40 }),
                    React.createElement(WaterFitNav_style_1.default.Value, null,
                        helpers_1.prettifyIfNumber(waterUsage),
                        " ",
                        isDesktop ? litresCopy : undefined)))),
            coins === null ? null : (React.createElement(ToolTip_1.default, { content: tooltips === null || tooltips === void 0 ? void 0 : tooltips.coins },
                React.createElement(WaterFitNav_style_1.default.ValueWrap, { "data-test": "coins" },
                    React.createElement(Icon_1.default, { icon: "coins", size: 40 }),
                    React.createElement(WaterFitNav_style_1.default.Value, null, helpers_1.prettifyIfNumber(coins || 0))))))));
};
exports.default = exports.WaterFitNav;
//# sourceMappingURL=WaterFitNav.js.map